import styled from 'styled-components';

const ContentsBodyText = styled.div`
  font-weight: 400;
  color: #5646ff;
  font-size: 16px;
`;

export default ContentsBodyText;
